var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("textarea", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.valueModel,
          expression: "valueModel"
        }
      ],
      staticClass: "form-control",
      attrs: { id: _vm.id },
      domProps: { value: _vm.valueModel },
      on: {
        input: function($event) {
          if ($event.target.composing) {
            return
          }
          _vm.valueModel = $event.target.value
        }
      }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }